module.exports = __webpack_public_path__ + "img/0Q3B9939-45_P_D_Source_Black_MockedUp.c8ef6735.jpg";